import { useActions } from "../../../../../hooks/useActions";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import { useTranslation } from "react-i18next";
import { TypeFilterItemsList } from "../../../../../share/filters";
import { FilterIdsEnum } from "../../../../../store/reducers/_maps/main/mapFilters/types";
import FilterButtonWithModal from "../../../../../share/filters/FilterButtonWithModal";
import { CustomCheckbox } from "../../../../../share/Input/Input";

const CompanySizeFilter = () => {
  const filterId: FilterIdsEnum = "cybersecurityCompanySize";
  const { company_size: selected } = useTypedSelector(
    (state) => state.cybersecurityMapFilters
  );
  const { company_size } = useTypedSelector(
    (state) => state.mapCybersecurityInfo.params
  );
  const {
    toggleCybersecurityCompanySize,
    cleanCybersecurityCompanySize,
    applyFilter,
  } = useActions();

  const handleClick = (option: string) => {
    toggleCybersecurityCompanySize(option);
    applyFilter();
  };

  const { t } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.cybersecurity.companySizeFilter",
  });
  const title = t("title");
  const pinText = selected.length > 0 && selected.length;

  return (
    <FilterButtonWithModal
      title={title}
      filterId={filterId}
      pinText={pinText}
      onClear={cleanCybersecurityCompanySize}
    >
      <TypeFilterItemsList>
        {company_size?.length &&
          company_size.sort().map((option: string) => (
            <CustomCheckbox
              value={option}
              checked={selected.includes(option)}
              onChange={() => handleClick(option)}
              key={option}
            >
              {option}
            </CustomCheckbox>
          ))}
      </TypeFilterItemsList>
    </FilterButtonWithModal>
  );
};

export default CompanySizeFilter;
